<div class="topmenu">
    <div class="topmenu-right">
        @if (showSearch) {
            @if (showMapDropdown) {
            <div class="topmenu-search">
                @if (showMapFilterSelector) {
                <p-select [(ngModel)]="mapFilterMode" [options]="mapFilterOptions" optionLabel="label" optionValue="value"
                    (onChange)="onMapFilterModeChange($event.value)" styleClass="map-filter-select" appendTo="body">
                </p-select>
                <div class="topmenu-search-divider"></div>
                }
                <div class="topmenu-search-left">
                    <i class="ri-search-line"></i>
                    <p-autoComplete
                        #mapAutoComplete
                        [(ngModel)]="searchText"
                        [suggestions]="mapSuggestions"
                        (completeMethod)="onMapSearch($event)"
                        (ngModelChange)="onSearchChange($event)"
                        (onFocus)="onMapInputFocus()"
                        [placeholder]="searchPlaceholder"
                        [minLength]="0"
                        [dropdown]="true"
                        styleClass="topmenu-autocomplete"
                        appendTo="body">
                    </p-autoComplete>
                </div>
            </div>
            } @else {
            <div class="topmenu-search" (click)="searchInput.focus()">
                <div class="topmenu-search-left">
                    <i class="ri-search-line"></i>
                    <input #searchInput type="text" pInputText [placeholder]="searchPlaceholder" [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)" />
                </div>
                @if (searchText) {
                    <i class="ri-close-line topmenu-search-clear" (click)="$event.stopPropagation(); clearSearch()"></i>
                }
            </div>
            }
        }
        <div class="notification-icon-wrapper">
            <button pButton type="button" icon="ri-notification-2-line" class="p-button-text p-button-rounded notification-icon-button"
                (click)="toggleNotificationPanel()">
            </button>
            @if (unreadCount() > 0) {
                <span class="notification-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
            }

            @if (showNotificationPanel()) {
                <div class="notification-dropdown-overlay" (click)="closeNotificationPanel()"></div>
                <div class="notification-dropdown">
                    <app-notification-panel (closePanel)="closeNotificationPanel()"></app-notification-panel>
                </div>
            }
        </div>

        <a routerLink="/support" pButton type="button" class="p-button-text p-button-rounded notification-icon-button" title="Support">
            <i class="ri-question-line"></i>
        </a>

        <a routerLink="/privacy-policy" pButton type="button" class="p-button-text p-button-rounded notification-icon-button" title="Privacy Policy">
            <i class="ri-shield-check-line"></i>
        </a>

        <div class="topmenu-divider"></div>

        <div class="user-profile-section">
            <div class="user-info">
                <span class="user-name">{{ userName }}</span>
                <span class="user-email">{{ userEmail }}</span>
            </div>
            <div class="user-avatar-wrapper">
                <p-avatar [label]="userInitials" size="normal" shape="circle" class="user-avatar"
                    (click)="userMenu.toggle($event)">
                </p-avatar>
                <button pButton type="button" icon="ri-arrow-down-s-line" class="p-button-text user-menu-trigger"
                    (click)="userMenu.toggle($event)">
                </button>
            </div>
        </div>

        <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body" styleClass="user-dropdown-menu">
        </p-menu>
    </div>
</div>

